// modified daniel.silva - we don't have active subscription, we have to manually import fontawesome-pro
//import '@fortawesome/fontawesome-pro/css/all.min.css'
import './fontawesome/fontawesome-pro/css/all.min.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
//import colors from 'vuetify/es5/util/colors'
// Our own translation file
import en from '../locale/en.ts'
import es from '../locale/es.ts'
import pt from '../locale/pt.ts'
import nl from '../locale/nl.ts'


Vue.use(Vuetify, {
    theme: {
        primary: process.env.VUE_APP_VUETIFY_PRIMARY,
        secondary: process.env.VUE_APP_VUETIFY_SECONDARY, //colors.orange.lighten2,
        accent: process.env.VUE_APP_VUETIFY_ACCENT,
        error: process.env.VUE_APP_VUETIFY_ERROR, //colors.red.darken2,
        warning: process.env.VUE_APP_VUETIFY_WARNING, //colors.yellow.darken2,
        info: process.env.VUE_APP_VUETIFY_INFO, //colors.blue.darken2,
        success: process.env.VUE_APP_VUETIFY_SUCCESS, //colors.green.darken2
    },
    options: {
        minifyTheme: function (css) {
            return process.env.NODE_ENV === 'production'
                ? css.replace(/[\s|\r\n|\r|\n]/g, '')
                : css
        }
    },
    customProperties: true,
    iconfont: 'fa',
    lang: {
        locales: {pt, en, es, nl},
        current: process.env.VUE_APP_LANG
    }
});
